export const endPoint = {
    development: "http://localhost:8080",
    production: "https://9job-be.allxone.vn",
  };
  